<template>
<div>
    <h1>Tutorials</h1>
    <v-row>
        <v-col cols="12" xs="12" lg="10">
            <v-card>

                <v-card-text>
                    <div v-for="(item, i) in completeTutorials" :key="`tut-${i}`">
                        <v-list-item>
                            <!-- <v-list-item-avatar :color="getColor(item)" tile>
                                <v-tooltip bottom>
                                    <span slot="activator">{{item.meta.level.slice(0,1).toUpperCase()}}</span>
                                    <span>{{item.meta.level}}</span>
                                </v-tooltip>
                            </v-list-item-avatar> -->
                            <v-list-item-content>
                                <v-list-item-title>{{item.name}}</v-list-item-title>
                                <v-list-item-subtitle>{{item.meta.description}}</v-list-item-subtitle>
                                <v-list-item-subtitle class="d-flex chips">
                                    <v-chip dark label small :color="getColor(item)">{{item.meta.level}}</v-chip>
                                    <v-chip dark label small v-for="(tag,t) in item.meta.tech" color="blue darken-1" :key="`tech-${t}`">{{tag}}</v-chip>
                                    <v-spacer />
                                    <v-chip dark label small v-for="(tag,t) in item.meta.authors" color="green darken-1" :key="`authors-${t}`">
                                        <v-icon>mdi-account</v-icon>{{tag}}
                                    </v-chip>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn color="primary" :to="`${item.path}`">more</v-btn>
                            </v-list-item-action>
                        </v-list-item>
                        <v-divider />
                    </div>
                </v-card-text>

                <v-card-text>
                    <h2> Upcoming Tutorials</h2>
                    <div v-for="(item, i) in incompleteTutorials" :key="`tut-${i}`" style="opacity:.3">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>{{item.name}}</v-list-item-title>
                                <v-list-item-subtitle>{{item.meta.description}}</v-list-item-subtitle>
                                <v-list-item-subtitle>
                                    <v-chip label small :color="getColor(item)">{{item.meta.level}}</v-chip>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn color="primary" :to="`${item.path}`">more</v-btn>
                            </v-list-item-action>
                        </v-list-item>
                        <v-divider />
                    </div>

                </v-card-text>

            </v-card>
        </v-col>

    </v-row>
</div>
</template>

<script>
import moment from "moment"
import routes from "../routes"

import uiView from "@/_mixins/ui-view-mixin"

export default {
    name: 'SamplePage',
    mixins: [uiView],
    created() {},
    props: {},
    watch: {},
    computed: {
        tutorials() {
            return routes.filter(e => e.name.toUpperCase().indexOf('TUTORIAL') >= 0);
        },
        incompleteTutorials() {
            return this.tutorials.filter(e => parseFloat(e.meta.version) < 1);
        },
        completeTutorials() {
            return this.tutorials.filter(e => parseFloat(e.meta.version) >= 1);
        },

    },
    data: () => ({

    }),
    methods: {
        getColor(item) {
            switch (item.meta.level) {
                case "beginner":
                    return 'blue';
                case "intermediate":
                    return 'purple';
                case "advanced":
                    return 'red darken-1';
                default:
                    return 'secondary';
            }
        }
    }

}
</script>

<style lang="scss">
.chips > *
{
    margin:0px 1px;
}
</style>
